import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop automatically resets the window scroll position to the top
 * whenever the route (pathname or search params) changes.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Instant scroll to the top of the page on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    // Fallback for full cross-browser compatibility
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
